import { sendRequest } from '../../hooks/requests/useRequest'

export async function getGlobalCredit (_date1,_date2)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Reports/GetReportFilterCredit/${_date1}/${_date2}`);

    if  (response.code === 200)
        return {
            code: response.code,
            data: response?.data
        }
    else
    {
        return response;
    }   
}

